module.exports = __webpack_public_path__ + "static/reverseIcon.0fe74d66.svg";